import { createSelector } from 'reselect';
import { Member, OrganizationMember } from '../../models/OrganizationMembers';
import { State } from '../../reducers/State';
import { organizationSelector } from '../Organization';

export function getMembershipPercentage(
  numRegisteredMembers?: number,
  numUnregisteredMembers?: number
): number | undefined {
  if (
    numRegisteredMembers === undefined ||
    numUnregisteredMembers === undefined
  ) {
    return undefined;
  }

  const numTotalMembers = numRegisteredMembers + numUnregisteredMembers;

  return numTotalMembers > 0
    ? Math.round((numRegisteredMembers / numTotalMembers) * 100)
    : 0;
}

export function organizationMemberSelector(
  state: State
): OrganizationMember | undefined {
  const organization = organizationSelector(state);

  if (!organization?.uuid || !state.organizationMembers) {
    return undefined;
  }

  return state.organizationMembers[organization.uuid];
}

export function currentMembersSelector(state: State): Member[] | undefined {
  const organizationMember = organizationMemberSelector(state);

  return organizationMember?.members;
}

export function numRegisteredMembersSelector(state: State): number | undefined {
  const currentMembers = currentMembersSelector(state);

  return currentMembers?.length;
}

export function numUnregisteredMembersSelector(
  state: State
): number | undefined {
  const organizationMember = organizationMemberSelector(state);

  return organizationMember?.missingMembers?.length ?? 0;
}

export const membershipPercentageSelector = createSelector(
  numRegisteredMembersSelector,
  numUnregisteredMembersSelector,
  getMembershipPercentage
);
